import Link from 'next/link';
import { useRouter } from 'next/router';

import { LoginStage } from '@/models/login.model';

interface LoginAuthOptionsProps {
  loginStage: LoginStage;
  setLoginStage: (stage: LoginStage) => void;
  className?: string;
}

export const LoginAuthOptions: React.FC<LoginAuthOptionsProps> = ({
  className,
  loginStage,
  setLoginStage,
}) => {
  const router = useRouter();
  const { query } = router;
  const hasSetup = Object.prototype.hasOwnProperty.call(query, 'setup');

  const renderStage = () => {
    switch (loginStage) {
      case LoginStage.emailPassword:
        return (
          <div className="flex items-center justify-around text-sm text-gray-600">
            <Link
              href="/forgot-password"
              className="hover:underline"
              aria-label="Reset your password"
            >
              Forgot your password?
            </Link>
            <button
              onClick={() => setLoginStage(LoginStage.passwordLessSend)}
              className="cursor-pointer hover:underline"
              aria-label="Switch to passwordless login"
            >
              Passwordless Login
            </button>
          </div>
        );
      case LoginStage.passwordLessSend:
      case LoginStage.passwordLessConfirm:
        return (
          <div className="flex items-center justify-between text-sm text-gray-600">
            <span></span>
            <button
              onClick={() => setLoginStage(LoginStage.emailPassword)}
              className="cursor-pointer hover:underline"
              aria-label="Switch to email and password login"
            >
              Email & Password
            </button>
          </div>
        );
    }
  };

  return (
    <div className="flex flex-col gap-4">
      {renderStage()}
      {hasSetup && (
        <div className="text-sm text-gray-600">
          New?{' '}
          <Link
            href="/register/account"
            className="hover:underline"
            aria-label="Register a new account"
          >
            Register an account
          </Link>
        </div>
      )}
    </div>
  );
};
